/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiveAddressVo1
 */
export interface ReceiveAddressVo1 {
    /**
     * 收货地址ID
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    id?: number;
    /**
     * 用户id，对应user表的id
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    userId?: number;
    /**
     * 国家id
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    nationId?: number;
    /**
     * 收件人姓名（韩文）
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    nameKr?: string;
    /**
     * 收件人姓名（英文）
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    nameEn?: string;
    /**
     * 收件人邮编
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    zip?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    address?: string;
    /**
     * 收件人详细地址
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    addressDetail?: string;
    /**
     * 收件人地址（英文）
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    addressEn?: string;
    /**
     * 收件人详细地址（英文）
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    addressDetailEn?: string;
    /**
     * 收件人电话
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    mobileNo?: string;
    /**
     * 证件类型
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    ctmsType?: number;
    /**
     * 证件号码
     * @type {string}
     * @memberof ReceiveAddressVo1
     */
    ctmsNo?: string;
    /**
     * 是否默认 0 不是， 1 是
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    defaultChoice?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof ReceiveAddressVo1
     */
    enable?: number;
}

/**
 * Check if a given object implements the ReceiveAddressVo1 interface.
 */
export function instanceOfReceiveAddressVo1(value: object): value is ReceiveAddressVo1 {
    return true;
}

export function ReceiveAddressVo1FromJSON(json: any): ReceiveAddressVo1 {
    return ReceiveAddressVo1FromJSONTyped(json, false);
}

export function ReceiveAddressVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiveAddressVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'addressEn': json['addressEn'] == null ? undefined : json['addressEn'],
        'addressDetailEn': json['addressDetailEn'] == null ? undefined : json['addressDetailEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'defaultChoice': json['defaultChoice'] == null ? undefined : json['defaultChoice'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function ReceiveAddressVo1ToJSON(json: any): ReceiveAddressVo1 {
    return ReceiveAddressVo1ToJSONTyped(json, false);
}

export function ReceiveAddressVo1ToJSONTyped(value?: ReceiveAddressVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'nationId': value['nationId'],
        'nameKr': value['nameKr'],
        'nameEn': value['nameEn'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'addressEn': value['addressEn'],
        'addressDetailEn': value['addressDetailEn'],
        'mobileNo': value['mobileNo'],
        'ctmsType': value['ctmsType'],
        'ctmsNo': value['ctmsNo'],
        'defaultChoice': value['defaultChoice'],
        'enable': value['enable'],
    };
}

